// ----------------------------------------------------------------------

export default function Paper(containerId: string) {
  return {
    MuiPaper: {
      defaultProps: {
        container: document.getElementById(containerId),
        elevation: 0,
      },

      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  };
}
